// eslint-disable-next-line import/no-anonymous-default-export
export default {
    baseURL: process.env.REACT_APP_API_URL + '/api'
}